import React from 'react';
import { Space, Tag } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
export const RegistrationRulesPreview = ({ registration_rules, registration_form }) => {
    try {
        const rules = registration_rules ? JSON.parse(registration_rules) : [];
        const form = registration_form ? JSON.parse(registration_form) : [];
        return (React.createElement(Space, { wrap: true },
            rules.map((group, index) => {
                var _a;
                return (React.createElement(React.Fragment, { key: index }, (_a = group.list) === null || _a === void 0 ? void 0 :
                    _a.map((item, idx) => (React.createElement(React.Fragment, { key: idx },
                        React.createElement(Tag, { color: "success" },
                            React.createElement(Space, null, Object.values(item).map((value, valueIdx) => (React.createElement("div", { key: valueIdx }, valueIdx === 0
                                ? _T('registration.rules.condition.' + value)
                                : value))))),
                        idx < group.list.length - 1 && (React.createElement(Tag, { color: "default" }, _T('common.or')))))),
                    index < rules.length - 1 && (React.createElement(Tag, { color: "red", style: { marginLeft: '10px' } }, _T('common.and')))));
            }),
            form.map((item, index) => (React.createElement(Tag, { color: item.required ? 'warning' : 'processing', key: index }, item.label)))));
    }
    catch (e) {
        console.error('Failed to parse registration rules:', e);
        return null;
    }
};
